var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-container power-box"
    },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "系统管理", url: "" },
                { label: "用户群组管理", url: "/system/usergroup" },
                { label: "查看用户群组", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "power-table" }, [
        _c("div", { staticClass: "basic-info" }, [
          _c("div", { staticClass: "main" }, [
            _c(
              "div",
              { staticClass: "basic-top" },
              [
                _c(
                  "el-row",
                  { staticClass: "row" },
                  [
                    _c("el-col", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            "font-weight": "bolder"
                          }
                        },
                        [_vm._v(_vm._s(_vm.group.userGroupName))]
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "row" },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("div", [
                        _vm._v("创建时间：" + _vm._s(_vm.group.createdTime))
                      ])
                    ]),
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("div", [
                        _vm._v("创建人：" + _vm._s(_vm.group.createdByName))
                      ])
                    ]),
                    _c("el-col", { attrs: { span: 6 } }, [
                      _vm._v("最后更新时间：" + _vm._s(_vm.group.updatedTime))
                    ]),
                    _c("el-col", { attrs: { span: 6 } }, [
                      _vm._v(
                        " 最后更新人：" + _vm._s(_vm.group.updatedByName) + " "
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "row" },
                  [
                    _c("el-col", [
                      _c("div", [
                        _vm._v(
                          "用户群组描述：" + _vm._s(_vm.group.groupDescribe)
                        )
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          [
            _vm._m(0),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.userList,
                  "highlight-current-row": "",
                  "tooltip-effect": "dark",
                  height: _vm.tableheight,
                  border: ""
                }
              },
              [
                _c("template", { slot: "empty" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "center"
                      }
                    },
                    [
                      _c("no-data", {
                        attrs: { height: "400px", width: "400px" }
                      })
                    ],
                    1
                  )
                ]),
                _c("el-table-column", {
                  attrs: {
                    prop: "systemName",
                    label: "人员",
                    "min-width": "80"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(
                                      scope.row.userName +
                                        "/" +
                                        scope.row.userId
                                    )
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(
                                  _vm._s(
                                    scope.row.userName + "/" + scope.row.userId
                                  )
                                )
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "permissionId",
                    label: "所在部门",
                    "min-width": "80"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(scope.row.pathName)
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(_vm._s(scope.row.pathName))
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              2
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          ref: "footer",
          staticStyle: {
            position: "sticky",
            bottom: "0",
            left: "0",
            right: "0",
            "background-color": "#fff",
            "border-top": "1px solid #ebeef5",
            "z-index": "100"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "right", padding: "10px" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  on: {
                    click: function($event) {
                      return _vm.back()
                    }
                  }
                },
                [_vm._v("返回")]
              ),
              _c(
                "el-popconfirm",
                {
                  attrs: { title: "确定删除此用户吗？" },
                  on: {
                    confirm: function($event) {
                      return _vm.delUserGroup()
                    }
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "20px" },
                      attrs: { slot: "reference", type: "primary" },
                      slot: "reference"
                    },
                    [_vm._v("删除")]
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.goToEdit()
                    }
                  }
                },
                [_vm._v("编辑")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "space-between" } },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "align-items": "center",
              "margin-bottom": "16px"
            }
          },
          [_vm._v(" 成员列表 ")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }